'use client';

import { useState, useEffect, type ReactNode } from 'react';

interface HeroEntranceProps {
  children: ReactNode;
  /** Stagger delay in ms. Default: 0 */
  delay?: number;
  className?: string;
}

/**
 * Wraps hero elements with a staggered entrance animation.
 * SSR: renders fully visible (no flash). Client: animates after hydration.
 */
export default function HeroEntrance({ children, delay = 0, className = '' }: HeroEntranceProps) {
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    const timer = requestAnimationFrame(() => {
      setShouldAnimate(true);
    });
    return () => cancelAnimationFrame(timer);
  }, []);

  const style: React.CSSProperties = shouldAnimate
    ? {
        animation: `hero-fade-up 700ms ease-out both`,
        animationDelay: `${delay}ms`,
      }
    : {};

  return (
    <div className={`hero-entrance ${className}`} style={style}>
      {children}
    </div>
  );
}
